import React from "react";
import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";
import PPCDashboardOverall from "dashboards/PPCDashboardOverall";
import PPCDashboardSearch from "dashboards/PPCDashboardSearch";
import PPCDashboardSocial from "dashboards/PPCDashboardSocial";
import PPCDashboardDisplay from "dashboards/PPCDashboardDisplay";
import PPCDashboardVideo from "dashboards/PPCDashboardVideo";
import DashboardSubheader from "dashboards/DashboardSubheader";
import jsDig from "utils/jsDig";
import updateParams from "utils/updateParams.js";
import dismissDataPullErrors from "utils/dismissDataPullErrors";
import { capitalize, uniq } from "lodash-es";

class PPCDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.setSelectedDashboard = this.setSelectedDashboard.bind(this);
    this.state = {
      tabLocation: "",
      selectedDashboard: 0,
      selectedPlatform: "all",
      showPpcErrors: (jsDig(["data_pull_errors"], this.props.ppc_section) && Object.keys(jsDig(["data_pull_errors"], this.props.ppc_section)).length > 0 && this.props.shared.user_is_employee) ? true : false,
      showSearchErrors: (jsDig(["data_pull_errors"], this.props.search_section) && Object.keys(jsDig(["data_pull_errors"], this.props.search_section)).length > 0 && this.props.shared.user_is_employee) ? true : false,
      showSocialErrors: (jsDig(["data_pull_errors"], this.props.social_section) && Object.keys(jsDig(["data_pull_errors"], this.props.social_section)).length > 0 && this.props.shared.user_is_employee) ? true : false,
      showDisplayErrors: (jsDig(["data_pull_errors"], this.props.display_section) && Object.keys(jsDig(["data_pull_errors"], this.props.display_section)).length > 0 && this.props.shared.user_is_employee) ? true : false,
      showVideoErrors: (jsDig(["data_pull_errors"], this.props.video_section) && Object.keys(jsDig(["data_pull_errors"], this.props.video_section)).length > 0 && this.props.shared.user_is_employee) ? true : false,
    };
  }

  setPlatform = (p) => {
    this.setState({selectedPlatform: p})
  }

  pullInProgress() {
    return (
      <div className="spin-shell">
        <div className="spin-container">
          <div className="spinner">
            <img src="https://marcopolo.me/static/images/loading.png" />
          </div>
          <div className="title">
            <span>A data pull is in progress.</span>
          </div>
          <div className="description">
            <p>This page is not available while the data pull is in progress.</p>
            <span></span> Please check back later or
            <span
              style={{ color: "blue", cursor: "pointer" }}
              onClick={() => {
                location.reload();
              }}>
              {" "}
              <b>refresh </b>
            </span>
            <span>the page.</span>
          </div>
        </div>
      </div>
    );
  }

  recalcInProgress() {
    return (
      <div className="spin-shell">
        <div className="spin-container">
          <div className="spinner">
            <img src="https://marcopolo.me/static/images/loading.png" />
          </div>
          <div className="title">
            <span>Data is being recalculated.</span>
          </div>
          <div className="description">
            <p>Your data pull has completed but data is recalculating</p>
            <span>Please be patient {this.props.shared && this.props.shared.user ? this.props.shared.user.first_name : "my guy"} and check back later or</span>
            <span
              style={{ color: "blue", cursor: "pointer" }}
              onClick={() => {
                location.reload();
              }}>
              {" "}
              <b>refresh </b>
            </span>
            <span>the page.</span>
          </div>
        </div>
      </div>
    );
  };

  displayErrors(section) {
    let configUrl = ""
    if (section == "ppc_section") {
      configUrl = "/datapulse/ppc-config?page=ppc"
    } else if (section == "search_section") {
      configUrl = "/datapulse/ppc-config?page=search"
    } else if (section == "social_section") {
      configUrl = "/datapulse/ppc-config?page=social"
    } else if (section == "display_section") {
      configUrl = "/datapulse/ppc-config?page=display"
    } else if (section == "video_section") {
      configUrl = "/datapulse/ppc-config?page=video"
    }
    return (
      <div className="spin-shell">
        <div className="spin-container" style={{height: "auto"}}>
          <div className="title text-danger">
            <span>There were errors on the last data pull</span>
          </div>
          <div className="description">
            {jsDig([section, "data_pull_errors"], this.props) && Object.keys(jsDig([section, "data_pull_errors"], this.props)).map((platform) => {
              const errorCounts = jsDig([section, "data_pull_errors", platform], this.props).reduce((map, val) => {map[val] = (map[val] || 0)+1; return map}, {} );
              return (
                <React.Fragment key={platform}>
                  <div style={{paddingTop: "30px"}}>
                    <h3 className="text-danger" style={{textAlign: "left"}}>{capitalize(platform)}:</h3>
                    <ul style={{listStyle: "none", textAlign: "left", paddingLeft: "10px"}}>
                      {uniq(jsDig([section, "data_pull_errors", platform], this.props)).map((errorMessage, index) => {
                        const length = errorCounts[errorMessage];
                        return (
                          <li key={index} style={{wordBreak: "break-word"}}>- {length > 1 ? `(${length}x) ` : ' '}{errorMessage}</li>
                        )
                      })}
                    </ul>
                  </div>
                </React.Fragment>
              )
            })}
            <div className="d-flex justify-content-center">
              <button
                className="btn btn-info mx-2"
                onClick={(e) => {
                  dismissDataPullErrors(jsDig([section, "id"], this.props), section.split("_")[0])
                  $(e.target).closest('.spin-shell').fadeOut();
                  setTimeout(() => {
                    if (section == "ppc_section") {
                      this.setState({ showPpcErrors: false })
                    } else if (section == "search_section") {
                      this.setState({ showSearchErrors: false })
                    } else if (section == "social_section") {
                      this.setState({ showSocialErrors: false })
                    } else if (section == "display_section") {
                      this.setState({ showDisplayErrors: false })
                    } else if (section == "video_section") {
                      this.setState({ showVideoErrors: false })
                    }
                  }, 1000)
                }}>
                Dismiss
              </button>
              <a
                className="btn btn-info mx-2"
                href={configUrl}
                onClick={() => {
                  dismissDataPullErrors(jsDig([section, "id"], this.props), section.split("_")[0])
                }}>
                Go to configs
              </a>
            </div>
          </div>
        </div>
      </div>
    )
  }

  changeSection(hashLoc = "ppc") {
    let exportButton = $(".ppc-export-pdf");
    let href = exportButton.attr("href").split("&section=")[0];
    exportButton.attr("href", href + "&section=" + hashLoc + "&dashboard=0");
  }

  componentDidMount() {
    const urlSearchParams = new URL(location.href).searchParams;
    let hashLoc = urlSearchParams.get("page");
    if (hashLoc) {
      this.setState({ tabLocation: hashLoc });
      updateParams("page", hashLoc, "dashboard");
      this.changeSection(hashLoc);
    } else {
      this.setState({ tabLocation: "paidSearch" });
      updateParams("page", "paidSearch", "dashboard");
      this.changeSection();
    }
  }

  selectTab(key) {
    this.setState({ tabLocation: key });
    this.setState({ selectedDashboard: 0 });
    this.changeSection(key);
    updateParams("page", key, "dashboard");
    setTimeout(() => window.dispatchEvent(new Event("resize")), 1);
    if (key === "paidDisplay") {
      $("#configure-btn").attr("href", `ppc-config?page=display&subpage=dashboard`);
    }
    if (key === "paidVideo") {
      $("#configure-btn").attr("href", `ppc-config?page=video&subpage=dashboard`);
    }
    if (key === "paidSocial") {
      $("#configure-btn").attr("href", `ppc-config?page=social&subpage=dashboard`);
    }
    if (key === "paidSearch") {
      $("#configure-btn").attr("href", `ppc-config?page=search&subpage=dashboard`);
    }
    if (key === "ppc") {
      $("#configure-btn").attr("href", `ppc-config?page=ppc&subpage=dashboard`);
    }
  }

  setSelectedDashboard(id) {
    this.setState({ selectedDashboard: id });
    let exportButton = $(".ppc-export-pdf");
    let href = exportButton.attr("href").split("&section=")[0];
    exportButton.attr("href", href + "&section=" + this.state.tabLocation + "&dashboard=" + id);
  }

  
  render() {

    const ppcDashboards = [{ name: "PPC: Overall", id: 0 }];
    const searchDashboards = [
      { name: "Search: Overall", id: 0 },
      ...this.props.search_section.campaign_groups.map((group) => ({ name: group.name, id: group.id })),
    ];
    const socialDashboards = [
      { name: "Social: Overall", id: 0 },
      ...this.props.social_section.campaign_groups.map((group) => ({ name: group.name, id: group.id })),
    ];
    const displayDashboards = [
      { name: "Display: Overall", id: 0 },
      ...this.props.display_section.campaign_groups.map((group) => ({ name: group.name, id: group.id })),
    ];
    const videoDashboards = [
      { name: "Video: Overall", id: 0 },
      ...this.props.video_section.campaign_groups.map((group) => ({ name: group.name, id: group.id })),
    ];

    let dashboards = [];
    switch (this.state.tabLocation) {
      case "ppc":
        dashboards = [...ppcDashboards];
        break;
      case "paidSearch":
        dashboards = [...searchDashboards];
        break;
      case "paidSocial":
        dashboards = [...socialDashboards];
        break;
      case "paidDisplay":
        dashboards = [...displayDashboards];
        break;
      case "paidVideo":
        dashboards = [...videoDashboards];
        break;
      default:
        dashboards = [];
        break;
    }

    const allPpcEnabled =
      this.props.search_section.enabled || this.props.social_section.enabled || this.props.display_section.enabled || this.props.video_section.enabled;

    const ppcPulling =
      jsDig(["data_pull_status", "shopify_data_pull"], this.props.ppc_section) &&
      jsDig(["data_pull_status", "shopify_data_pull"], this.props.ppc_section).length > 0;
    const searchPulling =
      (jsDig(["data_pull_status", "google_data_pull"], this.props.search_section) &&
        jsDig(["data_pull_status", "google_data_pull"], this.props.search_section).length > 0) ||
      (jsDig(["data_pull_status", "bing_data_pull"], this.props.search_section) &&
        jsDig(["data_pull_status", "bing_data_pull"], this.props.search_section).length > 0);
    const socialPulling =
      jsDig(["data_pull_status", "facebook_data_pull"], this.props.social_section) &&
      jsDig(["data_pull_status", "facebook_data_pull"], this.props.social_section).length > 0;
    const displayPulling =
      jsDig(["data_pull_status", "google_data_pull"], this.props.display_section) &&
      jsDig(["data_pull_status", "google_data_pull"], this.props.display_section).length > 0;
    const videoPulling =
      jsDig(["data_pull_status", "google_data_pull"], this.props.video_section) &&
      jsDig(["data_pull_status", "google_data_pull"], this.props.video_section).length > 0;

      const ppcRecalculating =
        jsDig(["data_pull_status", "recalculation"], this.props.ppc_section) &&
        jsDig(["data_pull_status", "recalculation"], this.props.ppc_section).length > 0;
      const searchRecalculating =
        (jsDig(["data_pull_status", "recalculation"], this.props.search_section) &&
          jsDig(["data_pull_status", "recalculation"], this.props.search_section).length > 0) ||
        (jsDig(["data_pull_status", "recalculation"], this.props.search_section) &&
          jsDig(["data_pull_status", "recalculation"], this.props.search_section).length > 0);
      const socialRecalculating =
        jsDig(["data_pull_status", "recalculation"], this.props.social_section) &&
        jsDig(["data_pull_status", "recalculation"], this.props.social_section).length > 0;
      const displayRecalculating =
        jsDig(["data_pull_status", "recalculation"], this.props.display_section) &&
        jsDig(["data_pull_status", "recalculation"], this.props.display_section).length > 0;
      const videoRecalculating =
        jsDig(["data_pull_status", "recalculation"], this.props.video_section) &&
        jsDig(["data_pull_status", "recalculation"], this.props.video_section).length > 0;


        let platformCount
        if (this.state.tabLocation === "paidSearch" || this.state.tabLocation === "") {
           platformCount = Object.keys(this.props["search_section"]["cc_data"]).length
        }
        if (this.state.tabLocation === "paidSocial") {
           platformCount = Object.keys(this.props["social_section"]["cc_data"]).length
        }
        if (this.state.tabLocation === "paidDisplay") {
           platformCount = Object.keys(this.props["display_section"]["cc_data"]).length
        }
        if (this.state.tabLocation === "paidVideo") {
           platformCount = Object.keys(this.props["video_section"]["cc_data"]).length
        }

    return (
      <>
        <DashboardSubheader
          search={this.props.search_section.campaign_groups ? this.props.search_section.campaign_groups : undefined}
          display={this.props.display_section.campaign_groups ? this.props.display_section.campaign_groups : undefined}
          video={this.props.video_section.campaign_groups ? this.props.video_section.campaign_groups : undefined}
          social={this.props.social_section.campaign_groups ? this.props.social_section.campaign_groups : undefined}
          tabLocation={this.state.tabLocation}
          setPlatform={this.setPlatform}
          platformName="ppc"
          platformCount={platformCount}
          dashboards={dashboards}
          selectedDashboard={this.state.selectedDashboard}
          setSelectedDashboard={this.setSelectedDashboard}
          service={this.state.tabLocation}
        />
        <div className="dashboard">
          <Tab.Container id="ppc-dashboard-tabs" defaultActiveKey="ppc" activeKey={this.state.tabLocation} onSelect={(k) => this.selectTab(k)}>
            <Nav variant="pills" className="nav-fill tabs-navigation row no-gutters row-cols-sm-1 row-cols-md-5">
              <Nav.Item className="col">
                <Nav.Link eventKey="paidSearch">Paid Search</Nav.Link>
              </Nav.Item>
              <Nav.Item className="col">
                <Nav.Link eventKey="paidSocial">Paid Social</Nav.Link>
              </Nav.Item>
              <Nav.Item className="col">
                <Nav.Link eventKey="paidDisplay">Display Ads</Nav.Link>
              </Nav.Item>
              <Nav.Item className="col">
                <Nav.Link eventKey="paidVideo">Video Ads</Nav.Link>
              </Nav.Item>
              <Nav.Item className="col">
                <Nav.Link eventKey="ppc">All PPC</Nav.Link>
              </Nav.Item>
            </Nav>
            <Tab.Content>
              <Tab.Pane eventKey="ppc">
                {ppcPulling ? (
                  this.pullInProgress()
                ) : ppcRecalculating ? (
                  this.recalcInProgress()
                  ) : this.state.showPpcErrors ? (
                  this.displayErrors("ppc_section")
                ) : (
                  <PPCDashboardOverall
                    {...this.props.ppc_section}
                    {...this.props.shared}
                    selectedDashboard={this.state.selectedDashboard}
                    enabled={allPpcEnabled}
                    search_section={this.props.search_section}
                    social_section={this.props.social_section}
                    display_section={this.props.display_section}
                    video_section={this.props.video_section}
                  />
                )}
              </Tab.Pane>
              <Tab.Pane eventKey="paidSearch">
                {searchPulling ? (
                  this.pullInProgress()
                ) : searchRecalculating ? (
                  this.recalcInProgress()
                  ) : this.state.showSearchErrors ? (
                  this.displayErrors("search_section")
                ) : (
                  <PPCDashboardSearch {...this.props.search_section} {...this.props.shared} selectedDashboard={this.state.selectedDashboard} />
                )}
              </Tab.Pane>
              <Tab.Pane eventKey="paidSocial">
                {socialPulling ? (
                  this.pullInProgress()
                ) : socialRecalculating ? (
                  this.recalcInProgress()
                  ) :  this.state.showSocialErrors ? (
                  this.displayErrors("social_section")
                ) : (
                  <PPCDashboardSocial {...this.props.social_section} {...this.props.shared} selectedDashboard={this.state.selectedDashboard} />
                )}
              </Tab.Pane>
              <Tab.Pane eventKey="paidDisplay">
                {displayPulling ? (
                  this.pullInProgress()
                ) : displayRecalculating ? (
                  this.recalcInProgress()
                  ) : this.state.showDisplayErrors ? (
                  this.displayErrors("display_section")
                ) : (
                  <PPCDashboardDisplay {...this.props.display_section} {...this.props.shared} selectedDashboard={this.state.selectedDashboard} />
                )}
              </Tab.Pane>
              <Tab.Pane eventKey="paidVideo">
                {videoPulling ? (
                  this.pullInProgress()
                ) : videoRecalculating ? (
                  this.recalcInProgress()
                  ) : this.state.showVideoErrors ? (
                  this.displayErrors("video_section")
                ) : (
                  <PPCDashboardVideo {...this.props.shared} {...this.props.video_section} selectedDashboard={this.state.selectedDashboard} />
                )}
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </div>
      </>
    );
  }
}

export default PPCDashboard;
